import { render } from "./ProblemView.vue?vue&type=template&id=4dc147f8"
import script from "./ProblemView.vue?vue&type=script&lang=ts"
export * from "./ProblemView.vue?vue&type=script&lang=ts"

import "./ProblemView.vue?vue&type=style&index=0&id=4dc147f8&lang=scss"
script.render = render

export default script